export const GET_PRINT_RX_TEMPLATE = "api/v1/preview/rx-template";
export const GET_USER_SETTINGS = "/api/v1/clinic/get-user-settings";
